module.exports = __webpack_public_path__ + "static/media/buy_like.c7e6b09f.svg";